"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotBattery = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotBattery = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M20.445 4.4c4.265.47 7.994 2.42 11.277 5.27 3.702 3.211 7.751 6.675 8.216 11.645.495 5.295-2.029 10.515-5.805 14.134-3.652 3.5-8.705 4.586-13.688 4.55-4.941-.036-10.202-.946-13.498-4.747-3.181-3.67-2.62-9.013-2.703-13.937-.084-5.062-1.216-10.827 2.23-14.426C9.93 3.282 15.56 3.862 20.445 4.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M38 23v-6M6.333 10h23.334A3.333 3.333 0 0 1 33 13.333v13.334A3.333 3.333 0 0 1 29.667 30H6.333A3.333 3.333 0 0 1 3 26.667V13.333A3.333 3.333 0 0 1 6.333 10Z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotBattery = SpotBattery;
SpotBattery.displayName = "SpotBattery";